import angular from 'angular';
import { includes } from 'lodash';
import '../../components/status';
import '../../services/display';
import '../../services/errors';
import 'angular-ui-tree';
import { get, clone, isEmpty } from 'lodash';

const module = angular.module('whyline.modals.display', [
  'whyline.components.status',
  'whyline.services.display',
  'whyline.services.errors',
  'ui.tree',
]);

const DisplayModalController = ($scope, $timeout, $uibModalInstance, $translate, dialog, NotificationService, DisplayService, ErrorService, displayId, currentPlace) => {
  'ngInject';

  $scope.place = currentPlace;
  $scope.itemsPopulated = {};
  const populateAlreadyShown = () => {
    $scope.itemsPopulated = Object.assign({},
      $scope.display.areasPopulated,
      $scope.display.linesPopulated
    );
  };

  $scope.arrayExternalIds = [];
  $scope.initialExternalIds = [];

  const validate = () => {
    const name = $scope.display.name;
    if (!name) {
      NotificationService.Warning($translate.instant('mandatory_display_name'));
      return false;
    }
    if (name.length < 2) {
      NotificationService.Warning($translate.instant('min_char_display_name'));
      return false;
    }
    if (!$scope.display.lines.length && !$scope.display.areas.length) {
      NotificationService.Warning($translate.instant('select_min_fila'));
      return false;
    }
    if (!$scope.display.callQuantity) {
      NotificationService.Warning($translate.instant('call_quantity_valid'));
      return false;
    }
    if ($scope.display.callQuantity < 3) {
      NotificationService.Warning($translate.instant('call_quantity_min'));
      return false;
    }
    if ($scope.display.callQuantity > 20) {
      NotificationService.Warning($translate.instant('call_quantity_max'));
      return false;
    }
    return true;
  };

  $scope.onlyNaturals = () => {
    $scope.display.callQuantity = parseInt(Math.abs($scope.display.callQuantity))
  }

  const dismissOnError = err => {
    const errorMessage = get(err, 'data.message', '');

    if ([401, 403, 404].indexOf(err.status) >= 0) {
      $uibModalInstance.close('cancel');
    } else if (err.status === 409 && errorMessage === 'display.external-id-already-in-use') {
      const externalIds = get(err, 'data.data.externalIds', []);

      if (externalIds.length) {
        NotificationService.Warning($translate.instant(errorMessage).replace('{externalIds}', externalIds.join(', ')));
      }
    } else {
      ErrorService.handler(err);
    }

    DisplayService.GetAllAsPromiseFromServer();
  };

  $scope.display = {
    lines: [],
    areas: [],
    linesPopulated: {},
    areasPopulated: {},
    hasMultimedia: true,
    showAreaName: true,
    callQuantity: 6,
    currentExternalId: '',
    externalIds: [],
  };

  if (displayId) {
    DisplayService.GetOnePopulatedAsPromiseFromServer(displayId)
      .then(display => {
        $timeout(() => {
          $scope.display = DisplayService.Copy(display);

          $scope.display.currentExternalId = '';
          $scope.arrayExternalIds = $scope.display.externalIds !== undefined
            ? $scope.display.externalIds.map(externalId => externalId.toLowerCase())
            : [];
          $scope.initialExternalIds = clone($scope.arrayExternalIds).filter(externalId => !isEmpty(externalId));

          populateAlreadyShown();
        });
      })
      .catch(err => dismissOnError(err));
  }

  $scope.save = () => {
    if (validate()) {
      if (displayId) {
        return DisplayService.Update($scope.display)
          .then(() => {
            NotificationService.Success($translate.instant('display_update_sicc'));
            $uibModalInstance.close('cancel');
          })
          .catch(err => dismissOnError(err));
      }

      return DisplayService.Create($scope.display).then(() => {
        NotificationService.Success($translate.instant('display_create_succ'));
        $uibModalInstance.close('cancel');
      })
        .catch(err => dismissOnError(err));
    }
  };

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.selectLine = selection => {
    const id = selection._id;

    if (selection.type === 'line') {
      if (!includes($scope.display.lines, selection._id)) {
        $scope.display.lines.push(id);
        $scope.display.linesPopulated[id] = selection;
        populateAlreadyShown();
      }
    } else if (selection.type === 'area') {
      if (!includes($scope.display.areas, selection._id)) {
        $scope.display.areas.push(id);
        $scope.display.areasPopulated[id] = selection;
        populateAlreadyShown();
      }
    }
  };

  $scope.remove = id => {
    const lineIndex = $scope.display.lines.indexOf(id);
    if (lineIndex >= 0) {
      $scope.display.lines.splice(lineIndex, 1);
      $scope.display.linesPopulated[id] = undefined;
      Reflect.deleteProperty($scope.display.linesPopulated, id);
      populateAlreadyShown();
    }
    const areaIndex = $scope.display.areas.indexOf(id);
    if (areaIndex >= 0) {
      $scope.display.areas.splice(areaIndex, 1);
      $scope.display.areasPopulated[id] = undefined;
      Reflect.deleteProperty($scope.display.areasPopulated, id);
      populateAlreadyShown();
    }
  };

  $scope.inputExternalId = event => {
    if (
      (event.which === 188 && !$scope.checkLessThanCharacter()) ||
      (event.which === 13 && $scope.display.currentExternalId !== ' ')
    ) {
      let externalId = $scope.display.currentExternalId.indexOf(',') !== -1
        ? $scope.display.currentExternalId.substring(0, $scope.display.currentExternalId.indexOf(','))
        : $scope.display.currentExternalId;

			if (!isEmpty(externalId)) {
				if ($scope.arrayExternalIds.indexOf(externalId.toLowerCase()) === -1) {
					$scope.display.externalIds.push(externalId.toLowerCase());
					$scope.arrayExternalIds.push(externalId.toLowerCase());
				}
      }

      $scope.display.currentExternalId = '';
    }
  };

  $scope.removeExternalId = externalId => {
		if ($scope.initialExternalIds.indexOf(externalId.toLowerCase()) !== -1) {
			dialog
				.confirm($translate.instant('external_id_remove'))
				.then(() => $scope.deleteExternalId(externalId))
				.catch(() => 'canceled');
		} else {
			$scope.deleteExternalId(externalId);
		}
	};

	$scope.deleteExternalId = externalIdToRemove => {
		$scope.display.externalIds = $scope.display.externalIds.filter(externalId => externalId !== externalIdToRemove.toLowerCase());
		$scope.arrayExternalIds = $scope.arrayExternalIds.filter(externalId => externalId !== externalIdToRemove.toLowerCase());
		$scope.initialExternalIds = $scope.initialExternalIds.filter(externalId => externalId !== externalIdToRemove.toLowerCase());
	};

  $scope.checkLessThanCharacter = () => {
    return /^(<)\1*$/.test($scope.display.currentExternalId) || $scope.display.currentExternalId.endsWith('<');
  };
};

module.exports = module.controller('DisplayModalController', DisplayModalController);
